import React from 'react';
import PropTypes from 'prop-types';
import './index.scss';
import ArrowIcon from '../../../common/icons/arrow-down-slim.svg';

const Options = ({ options, onClick, onHover, disabled }) => {
    const opts = options.map((o, i) => (
        <li
            key={i}
            className="option"
            id={o.id}
            onClick={() => !disabled && onClick(o.id)}
            onMouseEnter={() => !disabled && onHover && onHover(o.id)}
            onMouseLeave={() => !disabled && onHover && onHover(null)}
        >
            <div className={`option--text ${o.className || ''}`}>{o.name}</div>
            <div className="option--icon">
                <ArrowIcon />
            </div>
        </li>
    ));

    return <ol className={`options ${disabled ? 'disabled' : ''}`}>{opts}</ol>;
};

Options.propTypes = {
    options: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string.isRequired,
            name: PropTypes.string.isRequired,
            className: PropTypes.string,
        })
    ),
    onClick: PropTypes.func,
    onHover: PropTypes.func,
    disabled: PropTypes.bool,
};

export default Options;
